import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { LoginRequest } from '../dtos/loginRequest';
import { LoginResponse } from '../dtos/loginResponse';
import { RegistrarRequest } from '../dtos/registrarRequest';
import { CambiarPassword } from '../dtos/cambiarPassword';
import { environment } from 'src/environments/environment.development';

@Injectable({
  providedIn: 'root'
})

export class AuthService {
  
  private apiUrl = `${environment.apiUrl}/Usuarios/`;
  constructor(private http: HttpClient) {}

  login(data: LoginRequest): Observable<LoginResponse> {
    return this.http.post<LoginResponse>(`${this.apiUrl}login`, data);
  }

  registrar(data: RegistrarRequest): Observable<any> {
    return this.http.post(`${this.apiUrl}registrar`, data);
  }

  recuperarPassword(email: string): Observable<any> {
    return this.http.post(`${this.apiUrl}recuperar-password`, { email });
  }
  cambiarPassword(usuarioId:number,data: CambiarPassword): Observable<any> {
    return this.http.post(`${this.apiUrl}cambiar-password?usuarioId=${usuarioId}`, data);
  }
  cambiarPasswordForzado(usuarioId:number,nuevaPassword: string): Observable<LoginResponse> {
  return this.http.post<LoginResponse>(`${this.apiUrl}cambiar-password-forzado?usuarioId=${usuarioId}`, { nuevaPassword });
}

}
